// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"828bf3a6","168":"f5025987","227":"48a564f0","285":"9fbeae04","453":"453f2ef2","487":"8e61a7dd","552":"f1058c27","638":"47b8330e","734":"0e65bd9d","739":"4ec9efac","743":"69e9e5f6","859":"adb28c88","860":"1a5d1f4a","868":"5a9ca5c9","919":"8ce79099","977":"f501ddfe"}[chunkId] + ".chunk.js";
};